import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = targetDate - new Date().getTime();
      
      if (difference > 0) {
        return {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        };
      }
      
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="inline-flex items-center gap-6 bg-gradient-to-r from-[#1e3a8a]/20 via-[#3b82f6]/20 to-[#1e3a8a]/20 backdrop-blur-md px-8 py-4 rounded-full border border-[#d97706]/30 shadow-lg shadow-[#d97706]/20">
      <Clock className="w-6 h-6 text-[#d97706]" />
      <div className="flex gap-6">
        <div className="text-center">
          <div className="text-3xl font-bold text-white drop-shadow-[0_0_10px_rgba(217,119,6,0.5)]">{timeLeft.days}</div>
          <div className="text-xs text-gray-200 uppercase tracking-wider">Days</div>
        </div>
        <div className="text-2xl font-bold self-center text-[#d97706]">:</div>
        <div className="text-center">
          <div className="text-3xl font-bold text-white drop-shadow-[0_0_10px_rgba(217,119,6,0.5)]">{String(timeLeft.hours).padStart(2, '0')}</div>
          <div className="text-xs text-gray-200 uppercase tracking-wider">Hours</div>
        </div>
        <div className="text-2xl font-bold self-center text-[#d97706]">:</div>
        <div className="text-center">
          <div className="text-3xl font-bold text-white drop-shadow-[0_0_10px_rgba(217,119,6,0.5)]">{String(timeLeft.minutes).padStart(2, '0')}</div>
          <div className="text-xs text-gray-200 uppercase tracking-wider">Minutes</div>
        </div>
        <div className="text-2xl font-bold self-center text-[#d97706]">:</div>
        <div className="text-center">
          <div className="text-3xl font-bold text-white drop-shadow-[0_0_10px_rgba(217,119,6,0.5)]">{String(timeLeft.seconds).padStart(2, '0')}</div>
          <div className="text-xs text-gray-200 uppercase tracking-wider">Seconds</div>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
